<template>
  <v-row class="ma-3 justify-center">
    <v-col class="col-9">
      <v-card
        class="px-3 pt-3 pb-6 elevation-0"
      >
        <v-card-title :class="titleTextClass">
          {{ personData.personName }}
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col>
              <v-row class="subtitle-2 font-weight-bold">
                <v-col :class="labelTextClass">
                  ID
                </v-col>
              </v-row>
              <v-row class="body-2 mt-0">
                <v-col :class="`py-0 font-weight-medium ${valueTextClass}`">
                  {{ personData.personId }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-row class="subtitle-2 font-weight-bold">
                <v-col :class="labelTextClass">
                  Email
                </v-col>
              </v-row>
              <v-row class="body-2 mt-0">
                <v-col :class="`py-0 font-weight-medium ${valueTextClass}`">
                  {{ personData.personEmail }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card class="px-3 pt-3 pb-6 elevation-0">
        <v-card-subtitle class="font-weight-bold midgray--text text-uppercase">
          Profile
        </v-card-subtitle>

        <v-card-text>
          <v-row>
            <v-col>
              <v-row class="subtitle-2 font-weight-bold">
                <v-col :class="labelTextClass">
                  Status
                </v-col>
              </v-row>

              <v-row
                :class="`body-2 mt-0 ${isActiveColor}--text`"
              >
                <v-col class="col-auto py-0 font-weight-medium">
                  <font-awesome-icon
                    v-if="isActiveLabel === 'Active'"
                    :icon="['fas', 'check-circle']"
                  />

                  <font-awesome-icon
                    v-else-if="isActiveLabel === 'Inactive'"
                    :icon="['fas', 'times-circle']"
                  />

                  <font-awesome-icon
                    v-else-if="isActiveLabel === 'Deleted'"
                    :icon="['fas', 'trash-alt']"
                  />

                  <font-awesome-icon
                    v-else
                    :icon="['fas', 'question-circle']"
                  />

                  <span class="font-weight-bold">
                    {{ isActiveLabel }}
                  </span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-row class="subtitle-2 font-weight-bold">
                <v-col :class="`col-auto ${labelTextClass}`">
                  Level
                </v-col>
              </v-row>
              <v-row class="body-2 mt-0">
                <v-col :class="`py-0 font-weight-medium ${valueTextClass}`">
                  {{ level }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-row class="subtitle-2 font-weight-bold">
                <v-col :class="labelTextClass">
                  Role
                </v-col>
              </v-row>
              <v-row class="body-2 mt-0">
                <v-col :class="`py-0 font-weight-medium ${valueTextClass}`">
                  {{ role }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-row class="subtitle-2 font-weight-bold">
                <v-col :class="labelTextClass">
                  Networks
                </v-col>
              </v-row>
              <v-row class="body-2 mt-0">
                <v-col :class="`py-0 font-weight-medium ${valueTextClass}`">
                  {{ networks }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row>
            <v-col v-if="isInternal">
              <v-row class="subtitle-2 font-weight-bold">
                <v-col :class="labelTextClass">
                  Manager
                </v-col>
              </v-row>
              <v-row
                class="body-2 mt-0"
              >
                <v-col class="py-0 font-weight-medium">
                  <router-link :to="personPath.profile(person.managerPersonId)">
                    {{ personData.managerPersonName }}
                  </router-link>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card class="px-3 pt-3 pb-6 elevation-0">
        <v-card-subtitle class="font-weight-bold midgray--text text-uppercase">
          iAdOps Access Diagnostics
        </v-card-subtitle>

        <v-card-text>
          <v-row>
            <v-col>
              <v-row class="body-2 mt-0">
                <v-col class="col-auto py-0 font-weight-medium">
                  <font-awesome-icon
                    v-if="canAccessApps"
                    :icon="['fas', 'check-circle']"
                    class="bluegreen--text"
                  />
                  <font-awesome-icon
                    v-else
                    :icon="['fas', 'times-circle']"
                    class="toasted--text"
                  />
                  <span class="font-weight-bold ml-1">
                    {{ canAccessApps ? 'Access granted' : 'Access denied' }}
                  </span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row
            v-for="check in accessChecks"
            :key="check.label"
          >
            <v-col class="py-1">
              <v-row class="subtitle-2 font-weight-bold">
                <v-col :class="labelTextClass">
                  {{ check.label }}
                </v-col>
              </v-row>
              <v-row class="body-2 mt-0">
                <v-col class="col-auto py-0 font-weight-medium">
                  <font-awesome-icon
                    v-if="check.ok"
                    :icon="['fas', 'check-circle']"
                    class="bluegreen--text"
                  />
                  <font-awesome-icon
                    v-else
                    :icon="['fas', 'times-circle']"
                    class="toasted--text"
                  />
                  <span
                    :class="check.ok ? valueTextClass : 'toasted--text'"
                    class="ml-1"
                  >
                    {{ check.value }}
                  </span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-row class="subtitle-2 font-weight-bold">
                <v-col :class="labelTextClass">
                  Access Errors
                </v-col>
              </v-row>
              <v-row class="body-2 mt-0">
                <v-col class="py-0 font-weight-medium">
                  <ul
                    v-if="accessErrors.length > 0"
                    class="diagnostics-list"
                  >
                    <li
                      v-for="error in accessErrors"
                      :key="`access-${error}`"
                      class="toasted--text"
                    >
                      {{ error }}
                    </li>
                  </ul>
                  <span
                    v-else
                    :class="valueTextClass"
                  >
                    None
                  </span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-row class="subtitle-2 font-weight-bold">
                <v-col :class="labelTextClass">
                  Auth Errors
                </v-col>
              </v-row>
              <v-row class="body-2 mt-0">
                <v-col class="py-0 font-weight-medium">
                  <ul
                    v-if="authErrors.length > 0"
                    class="diagnostics-list"
                  >
                    <li
                      v-for="error in authErrors"
                      :key="`auth-${error}`"
                      class="toasted--text"
                    >
                      {{ error }}
                    </li>
                  </ul>
                  <span
                    v-else
                    :class="valueTextClass"
                  >
                    None
                  </span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Settings Section -->
      <v-card class="px-3 pt-3 pb-6 elevation-0">
        <!-- Settings Section Header -->
        <v-card-subtitle class="font-weight-bold midgray--text text-uppercase">
          Settings
        </v-card-subtitle>

        <!-- Settings Content -->
        <v-card-text
          v-if="settings && settings.length"
          class="body-2"
        >
          <v-card
            v-for="(settingType, settingName) in settings"
            :key="settingName"
            class="mb-2 elevation-1"
          >
            <v-toolbar
              color="offwhite"
              class="elevation-0"
            >
              <v-toolbar-title class="subtitle-2 text-capitalize">
                {{ settingName }}
              </v-toolbar-title>
            </v-toolbar>

            <v-list>
              <v-list-group
                v-for="(setting, settingIndex) in settingType"
                :key="settingIndex"
                v-model="setting.active"
                :prepend-icon="setting.action"
                no-action
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title
                      class="body-2 font-weight-medium"
                      v-text="setting.name"
                    />
                  </v-list-item-content>
                </template>

                <v-list-item v-if="setting.parameters">
                  <v-col>
                    <v-row v-if="canEditSettings">
                      <v-dialog
                        v-model="showSettingsForm"
                        scrollable
                        persistent
                        max-width="500px"
                        transition="dialog-transition"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-spacer />

                          <v-btn
                            color="primary lighten-2"
                            dark
                            v-bind="attrs"
                            v-on="on"
                          >
                            Edit
                          </v-btn>
                        </template>

                        <settings-form :setting="setting" />
                      </v-dialog>
                    </v-row>

                    <v-row>
                      <v-col>
                        <v-row>
                          <v-col>
                            <div class="font-weight-bold">
                              Name
                            </div>
                            <div>
                              {{ setting.name || 'Unnamed' }}
                            </div>
                          </v-col>
                        </v-row>

                        <v-row
                          v-if="setting.network"
                        >
                          <v-col>
                            <div class="font-weight-bold">
                              Networks
                            </div>
                            <div
                              v-for="(network, networkIndex) in setting.network"
                              :key="networkIndex"
                            >
                              {{ getOrgAndTeamName(network) }}
                            </div>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col>
                            <div class="font-weight-bold">
                              Reports
                            </div>
                            <div>
                              {{ setting.reports.join(', ') }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col class="font-weight-bold">
                        <v-row>
                          <v-col class="col-4 py-0">
                            Property
                          </v-col>
                          <v-col class="col-2 py-0">
                            Operator
                          </v-col>
                          <v-col class="py-0 font-weight-medium">
                            Value
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-row
                      v-for="(params, paramName) in setting.parameters"
                      :key="paramName"
                    >
                      <v-col class="col-4 pt-0">
                        {{ paramName }}
                      </v-col>

                      <v-col class="mb-6">
                        <v-row
                          v-for="(param, paramIndex) in params"
                          :key="paramIndex"
                        >
                          <v-col class="col-3 py-0">
                            {{ param.operator }}
                          </v-col>
                          <v-col class="py-0 font-weight-medium">
                            {{ param.value }}
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-list-item>

                <v-list-item v-else>
                  {{ JSON.stringify(setting) }}
                </v-list-item>
              </v-list-group>
            </v-list>
          </v-card>
        </v-card-text>

        <!-- No Settings Message -->
        <v-card-text v-else>
          <span :class="labelTextClass">
            None
          </span>
        </v-card-text>
      </v-card>

      <!-- Change Log Section -->
      <v-card
        class="px-3 pt-3 pb-6 elevation-0"
      >
        <!-- Change Log Section Header -->
        <v-card-subtitle class="mb-4 font-weight-bold midgray--text text-uppercase">
          Change Log
        </v-card-subtitle>

        <!-- Change Log Section Content -->
        <v-card-text>
          <v-row>
            <v-col>
              <!-- Created On -->
              <v-row class="body-2 mb-4">
                <v-col class="py-0 font-weight-bold">
                  <v-row>
                    <v-col :class="`pb-0 ${labelTextClass}`">
                      Created On
                    </v-col>
                  </v-row>

                  <v-row class="mt-0">
                    <v-col :class="`${valueTextClass} font-weight-medium`">
                      {{ createdOn }}
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <!-- Created By -->
              <v-row class="body-2 mb-4">
                <v-col class="py-0 font-weight-bold">
                  <v-row>
                    <v-col :class="`pb-0 ${labelTextClass}`">
                      Created By
                    </v-col>
                  </v-row>

                  <v-row class="mt-0">
                    <v-col :class="`${valueTextClass} font-weight-medium`">
                      {{ createdBy }}
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <!-- Updated On -->
              <v-row
                v-if="updatedBy"
                class="body-2 mb-4"
              >
                <v-col class="py-0 font-weight-bold">
                  <v-row>
                    <v-col :class="`pb-0 ${labelTextClass}`">
                      Updated On
                    </v-col>
                  </v-row>

                  <v-row class="mt-0">
                    <v-col :class="`${valueTextClass} font-weight-medium`">
                      {{ updatedOn }}
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <!-- Updated By -->
              <v-row
                v-if="updatedBy"
                class="body-2 mb-4"
              >
                <v-col class="py-0 font-weight-bold">
                  <v-row>
                    <v-col :class="`pb-0 ${labelTextClass}`">
                      Updated By
                    </v-col>
                  </v-row>

                  <v-row class="mt-0">
                    <v-col :class="`${valueTextClass} font-weight-medium`">
                      {{ updatedBy }}
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import dates from 'src/utils/dates'
import themeClasses from '@/mixins/themeClasses'
import SettingsForm from './SettingsForm'
import { personPath } from '@/utils/internalPaths'

const { mapGetters: mapAuthGetters } = createNamespacedHelpers('auth')
const { mapState: mapInternalState } = createNamespacedHelpers('internal')
const { mapState: mapLayoutState } = createNamespacedHelpers('layout')
const { mapGetters: mapToolsGetters, mapState: mapToolsState } = createNamespacedHelpers('tools')

export default {
  name: 'PersonProfile',
  components: {
    SettingsForm,
  },
  mixins: [themeClasses],
  props: {
    person: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      personPath,
    }
  },
  computed: {
    ...mapAuthGetters([
      'inDarkMode',
      'isUserInternalAdmin',
    ]),
    ...mapToolsGetters(['currentViewId', 'teams']),
    ...mapLayoutState({
      icons: (state) => state.icons,
      valueIcons: (state) => state.icons.values,
    }),
    ...mapToolsState({
      selectedSearch: (state) => state.selectedSearch,
    }),
    ...mapInternalState({
      didLoadPersonFail: (state) => state.didLoadPersonFail,
      isSettingsModalVisible: (state) => state.isSettingsModalVisible,
    }),
    titleTextClass() {
      return this.themeTextClass('darkblue', 'icewhite')
    },
    labelTextClass() {
      return this.themeTextClass('midgray', 'icewhite')
    },
    valueTextClass() {
      return this.themeTextClass('nearblack', 'icewhite')
    },
    personData() {
      const personUnknown = {
        access: { permissions: {} },
        personNameFirst: 'Unknown',
        personNameLast: 'Person',
        settings: {},
      }

      // Use person prop if provided (from Person.vue component-level state)
      // Otherwise fall back to selectedSearch (from Vuex store)
      return this.person || this.selectedSearch || personUnknown
    },
    canEditSettings() {
      // return this.isUserInternalAdmin
      return false
    },
    isDeleted() {
      const { personData = {} } = this
      const { isDeleted } = personData

      return isDeleted
    },
    isActive() {
      const { personData = {} } = this
      const { access = {} } = personData
      const { active } = access

      return active
    },
    isActiveColor() {
      const { isActive, valueIcons } = this
      const status = String(isActive)
      const { color } = valueIcons[status] || {}

      return color || this.themeSurfaceColor('midgray', 'icewhite')
    },
    isActiveLabel() {
      if (this.isDeleted) return 'Deleted'
      return this.isActive ? 'Active' : 'Inactive'
    },
    isInternal() {
      const { personData = {} } = this
      const { access = {} } = personData
      const { role } = access

      return role === 'internal'
    },

    networks() {
      const { personData = {} } = this
      const { network: networks } = personData

      if (!networks?.length) return 'Not Assigned'

      return networks.map((network) => {
        const { organization, team } = network
        const { code: billingCode } = organization || {}

        if (!billingCode) return 'ERROR_CONFIG_ORGANIZATION'

        return team.map((t) => {
          const teamCode = t.code

          if (!teamCode) return 'ERROR_CONFIG_TEAM'

          if (teamCode === '-1') return billingCode

          return `${billingCode} (Team ${t.code})`
        }).join(', ')
      }).join(', ')
    },
    level() {
      const { personData = {} } = this
      const { access = {} } = personData
      const { level } = access

      return level || 'U/K'
    },
    role() {
      const { personData = {} } = this
      const { access = {} } = personData
      const { role } = access

      return role || 'U/K'
    },
    settings: {
      get() {
        const { personData = {} } = this
        const { settings = [] } = personData

        if (typeof settings !== 'object') {
          return { error: 501, details: personData, layer: 'data', message: 'Corrupted' }
        }

        return settings
      },
      set(newValue) {
        const currentSettings = this.personData.settings

        // Map newValue over settings
        this.personData.settings = Object.entries(newValue).reduce((acc, [key, value]) => {
          acc[key] = value.map((setting) => ({
            ...setting,
            active: setting.active || false,
          }))
          return acc
        }, currentSettings)
      },
    },
    showSettingsForm: {
      get() {
        return this.isSettingsModalVisible
      },
      set(newValue) {
        this.$store.commit('internal/isSettingsModalVisible', newValue)
      },
    },
    createdBy() {
      const { personData = {} } = this
      const unknownActor = 'Unknown'
      const { assoc_email = unknownActor, updated_dt } = personData

      return !updated_dt ? assoc_email : unknownActor
    },
    createdOn() {
      const { personData = {} } = this
      const { created_dt } = personData

      return dates.getFormattedLocalDateTime(created_dt)
    },
    updatedBy() {
      const { personData = {} } = this
      const { assoc_email } = personData

      return assoc_email
    },
    updatedOn() {
      const { personData = {} } = this
      const { updated_dt } = personData

      return dates.getFormattedLocalDateTime(updated_dt)
    },
    canAccessApps() {
      return this.personData?.canAccessApps === true
    },
    isConfigValid() {
      return this.personData?.isConfigValid !== false
    },
    isPersonAuthorized() {
      return this.personData?.isPersonAuthorized === true
    },
    isUserAuthorized() {
      return this.personData?.isUserAuthorized === true
    },
    hasActiveOrgs() {
      const activeOrgs = this.personData?.hasActiveOrgs
      return Array.isArray(activeOrgs) ? activeOrgs.length > 0 : !!activeOrgs
    },
    accessErrors() {
      const errors = this.personData?.hasAccessErrors
      return Array.isArray(errors) ? errors : []
    },
    authErrors() {
      const errors = this.personData?.hasAuthErrors
      return Array.isArray(errors) ? errors : []
    },
    isUserActiveStatus() {
      return this.personData?.isUserActive === true
    },
    accessChecks() {
      let activeOrganizationsValue = 'No active organizations assigned'

      if (this.isInternal) {
        activeOrganizationsValue = 'Not required for internal users'
      } else if (this.hasActiveOrgs) {
        activeOrganizationsValue = 'Has at least one active organization'
      }

      return [
        {
          label: 'Person Authorization',
          ok: this.isPersonAuthorized,
          value: this.isPersonAuthorized ? 'Person is active and not deleted' : 'Person is inactive or deleted',
        },
        {
          label: 'User Authorization',
          ok: this.isUserAuthorized,
          value: this.isUserAuthorized ? 'User is active and not expired' : 'User is inactive or expired',
        },
        {
          label: 'User Active',
          ok: this.isUserActiveStatus,
          value: this.isUserActiveStatus ? 'User is active' : 'User is inactive',
        },
        {
          label: 'Config Validation',
          ok: this.isConfigValid,
          value: this.isConfigValid ? 'No config validation errors' : 'Config has validation errors',
        },
        {
          label: 'Active Organizations',
          ok: this.isInternal || this.hasActiveOrgs,
          value: activeOrganizationsValue,
        },
      ]
    },
  },
  methods: {
    getOrgAndTeamName(network) {
      const orgTeam = this.teams.find((team) => team.billingCode === network.billingCode && team.teamId === network.teamId && team.teamCode === network.teamCode)
      return orgTeam?.teamName || 'Unknown Team Name'
    },
  },
}
</script>

<style lang="scss" scoped>
.v-card__subtitle {
  letter-spacing: 0.025rem;
}

.diagnostics-list {
  margin: 0;
  padding-left: 1rem;
}
</style>
